import Layout from "components/layout";
import PatentTranslation from "components/reusableComponents/patenttranslation/PatentTranslation";
import React from "react";
import SEO from "components/seo";

function index() {
  const description = "";
  const title = "";
  const keywords = "";
  return (
    <Layout>
      <SEO
        title={title}
        description={description}
        keywords={keywords}
        slug="/patent-translation"
      />
      <PatentTranslation />
    </Layout>
  );
}

export default index;
